if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
        });
      }

      // Start autoplay
      this.autoplay();
    }

    changeSlide(direction) {

      if (direction === 'next') {
        this.index++;
        if (this.index >= this.length) {
          this.index = 0; // Loop to the first slide
        }
      } else if (direction === 'prev') {
        this.index--;
        if (this.index < 0) {
          this.index = this.length - 1; // Loop to the last slide
        }
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

    autoplay() {
      setInterval(() => {
        this.changeSlide('next');
      }, 3000); // Change slide every 3 seconds
    }

  }

  if (typeof customElements.get('announcement-bar') === 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}
